import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {CallState, SipHeaderService} from '../sip-header.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-call-icon',
    templateUrl: './call-icon.component.html',
    styleUrls: ['./call-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CallIconComponent implements OnInit, OnDestroy {

  callAvailable = false;
  private sub!: Subscription;

  constructor(
    private SipHeaderService: SipHeaderService,
    private cdr: ChangeDetectorRef,
  ) {
  }

  ngOnInit() {
    this.sub = this.SipHeaderService.isCallable$.subscribe(value => {
      console.log('isCallable$', value);
      this.callAvailable = value === CallState.connected;
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe(); // важно отписаться, чтобы избежать утечек памяти
  }

}
